"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waiver = void 0;
exports.waiver = {
    id: '21212121-2121-2121-2121-211121112112'
};
